import DOMPurify from "dompurify";
import { addLocale, locale } from "primereact/api";
import { showInfoToast } from "./toast";

export const initLocaleVariables = () => {
  addLocale("es", {
    startsWith: "Empieza con",
    contains: "Contiene",
    notContains: "No contiene",
    endsWith: "Termina con",
    equals: "Igual",
    notEquals: "Distinto",
    noFilter: "Sin filtro",
    filter: "Filtro",
    lt: "Menos que",
    lte: "Menos o igual que",
    gt: "Más que",
    gte: "Más o igual que",
    dateIs: "Fecha es",
    dateIsNot: "Fecha no es",
    dateBefore: "Fecha antes",
    dateAfter: "Fecha despues",
    custom: "Personalizado",
    clear: "Limpiar",
    apply: "Aplicar",
    matchAll: "Coincidir con todo",
    matchAny: "Coincidir con cualquiera",
    addRule: "Agregar regla",
    removeRule: "Borrar regla",
    accept: "Si",
    reject: "No",
    choose: "Elegir",
    upload: "Cargar",
    cancel: "Cancelar",
    close: "Cerrar",
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    weekHeader: "Sem",
    firstDayOfWeek: 1,
    dateFormat: "dd/mm/yy",
    weak: "Débil",
    medium: "Medio",
    strong: "Fuerte",
    passwordPrompt: "Ingresar una contraseña",
    emptyFilterMessage: "Opción no válida",
    emptyMessage: "No se encontraron resultados",
    trueLabel: "Verdadero",
    falseLabel: "Falso",
    nullLabel: "No seleccionado",
    pageLabel: "Página",
    firstPageLabel: "Primera página",
    lastPageLabel: "Última página",
    nextPageLabel: "Siguiente página",
    previousPageLabel: "Página anterior",
    selectLabel: "Seleccionae",
    unselectLabel: "Deseleccionar",
    expandLabel: "Expandir",
    collapseLabel: "Colapsar",
  });

  locale("es");
};
export const findIndexById = (products, id) => {
  let index = -1;
  for (let i = 0; i < products.length; i++) {
    if (products[i].id === id) {
      index = i;
      break;
    }
  }
  return index;
};

export const createId = () => {
  let id = "";
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 5; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return id;
};

export const findArrayIndexById = (products, id, indexId) => {
  let index = -1;
  for (let i = 0; i < products.length; i++) {
    if (products[i][indexId] === id) {
      index = i;
      break;
    }
  }
  return index;
};

export const replaceCharacter = (text, c1, c2) => {
  if (text) {
    return text.replaceAll(c1, c2);
  } else return "";
};

export const getDatetime = (text) => {
  return text.slice(-8, -2);
};

export const formatDate = (dateStr) => {
  try {
    var dArr = dateStr.split("-");
    return dArr[2] + "/" + dArr[1] + "/" + dArr[0];
  } catch (error) {
    return "";
  }
};

export const validateInput = (type, value) => {
  const rgx = {
    email: "^[a-zA-Z0-9\u00f1\u00d1@_.-]*$",
    text: "^[A-Za-zÀ-ÿ0-9\u00f1\u00d1!¡¿?_.,: -]*$",
    textNoEspace: "^[A-Za-zÀ-ÿ0-9\u00f1\u00d1¿?_.-]*$",
    username: "^[A-Za-z0-9\u00f1\u00d1]*$",
    alphanumeric: "^[A-Za-z0-9À-ÿ\u00f1\u00d1!¡¿?_.,-]*$",
    number: "^[0-9]*$",
    real: "^[0-9?,.]*$",
  };
  let typeValidation = true;
  if (type !== "all" && type !== "password" && type !== "date") {
    typeValidation = value.match(rgx[type]) != null;
  }
  if (typeValidation && !(value.match("[<>']") != null)) {
    return true;
  } else return false;
};

export const isObjEmpty = (obj) => {
  return Object.values(obj).length === 0 && obj.constructor === Object;
};

export const getDateNow = () => {
  let today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }
  return day + "/" + month + "/" + today.getFullYear();
};

export const getTimeNow = () => {
  let today = new Date();
  let hours = today.getHours();
  let minutes = today.getMinutes();
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  return hours + ":" + minutes;
};
export const moveElementToTop = (list, id) => {
  list.forEach((item, i) => {
    if (item.id === id) {
      list.splice(i, 1);
      list.unshift(item);
    }
    return list;
  });
};

export const checkDuplicateItemsbyId = (array) => {
  let valuesSoFar = Object.create(null);
  for (let i = 0; i < array.length; ++i) {
    let value = array[i].id;
    if (value in valuesSoFar) {
      return true;
    }
    valuesSoFar[value] = true;
  }
  return false;
};

export const checkEmptyBranchItemsbyId = (array) => {
  for (let i = 0; i < array.length; ++i) {
    if (array[i].question === "" || array[i].id === "") {
      return true;
    }
  }
  return false;
};

export const checkEmptyAdItemsbyId = (array) => {
  for (let i = 0; i < array.length; ++i) {
    if (array[i].values === "" || array[i].id === "") {
      return true;
    }
  }
  return false;
};

export const scrollToBottomRef = (ref) => {
  setTimeout(() => ref.current?.scrollIntoView({ behavior: "smooth" }), 100);
};

export const has24HoursPassedSince = (dateString) => {
  try {
    const providedDate = new Date(dateString);
    const currentDate = new Date();
    const millisecondsDifference = currentDate - providedDate;
    const hoursDifference = millisecondsDifference / (1000 * 60 * 60);
    return hoursDifference >= 24;
  } catch (error) {
    return true;
  }
};
export const formatText = (text, lineBreak = true) => {
  try {
    const clean = DOMPurify.sanitize(text);
    let formattedText = clean
      .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>") // Negrita
      .replace(/_(.*?)_/g, "<i>$1</i>") // Cursiva
      .replace(
        /\[(.*?)\]\((.*?)\)/g,
        "<a href='$2' target='_blank' rel='noopener noreferrer'>$1</a>"
      ); // Hipervínculo
    if (lineBreak) {
      formattedText = formattedText.replace(/\\n/g, "</br >"); // Salto de linea
    } else {
      formattedText = formattedText.replace(/\\n/g, ""); // Salto de linea
    }
    return formattedText;
  } catch (error) {
    return "Hubo un error al procesar el texto";
  }
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Formatea para que siempre tenga 2 dígitos
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      let data = {
        filename: file.name ?? new Date().toISOString(),
        size: file.size,
        type: file.type,
        file: fileReader.result.split("base64,")[1],
      };
      resolve(data);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const validateExpressions = (newExample, expressions) => {
  if (expressions.length < 2) {
    if (
      expressions.length === 1 &&
      !newExample.includes(expressions[0].selectedText)
    ) {
      showInfoToast("El valor no se encuentra en el ejemplo.");
      return false;
    }
    return true;
  }
  const base = newExample;
  let positions = [];
  for (let i = 0; i < expressions.length; i++) {
    let word = expressions[i].selectedText;
    let index = base.indexOf(word);
    if (index !== -1) {
      positions.push({ start: index, end: index + word.length });
    } else {
      showInfoToast("Un valor no se encuentra en el ejemplo.");
      return false;
    }
    let newExpressions = [...expressions];
    newExpressions.splice(i, 1);
    if (
      newExpressions?.some(
        (item) =>
          item.selectedText !== expressions[i].selectedText &&
          item.entity == expressions[i].entity &&
          item.entityValue == expressions[i].entityValue
      )
    ) {
      showInfoToast("No se puede asignar a dos valores la misma entidad.");
      return false;
    }
  }
  positions.sort((a, b) => a.start - b.start);
  for (let i = 0; i < positions.length - 1; i++) {
    if (positions[i].end > positions[i + 1].start) {
      showInfoToast("Hay valores que se superponen en el ejemplo.");
      return false;
    }
  }
  return true;
};

export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "ARS":
      return "$";
    case "USD":
      return "U$D";
    default:
      return "$";
  }
};
